import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import Marquee from "../components/Marquee"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class AllProducts extends Component {
  constructor(obj) {
    super(obj)

    this.marqueeDOM = qs(".marquee", this.el)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    gsap.set(this.el, { autoAlpha: 0 })
  }

  on() {
    this.marquee = new Marquee(this.marqueeDOM)
  }

  resize() {
    this.marquee.resize()
  }

  animate() {
    const products = qsa(".product", this.el)
    const title = qsa(".title-wrapper .char-0", this.el)
    const number = qs(".number", this.el)
    const cta = qs(".cta-wrapper", this.el)

    gsap.from(title, {
      y: 50,
      duration: 1.2,
      stagger: 0.03,
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })

    gsap.from(number, {
      y: 50,
      duration: 1.2,
      scrollTrigger: {
        trigger: number,
        start: "top bottom",
      },
    })

    gsap.from(products, {
      y: 120,
      duration: 1.2,
      stagger: 0.05,
      autoAlpha: 0,
      scrollTrigger: {
        trigger: products,
        start: "top bottom",
      },
    })

    gsap.from(cta, {
      y: 50,
      autoAlpha: 0,
      duration: 1.2,
      scrollTrigger: {
        trigger: cta,
        start: "top bottom",
      },
    })

    gsap.set(this.el, { autoAlpha: 1 })
  }
}
